import { defineLocale } from "ngx-bootstrap/chronos";
import { ComponentCanDeactivate } from "./../../guards/pending-changes.guard";
import { StrengthWorkoutService } from "./../../services/strength-workout.service";
import { ActivatedRoute, Router } from "@angular/router";
import { NgForm } from "@angular/forms";
import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from "@angular/core";
import Swal from "sweetalert2/src/sweetalert2.js";
import { AchievementService } from "src/app/services/achievement.service";
import moment from "moment";
import { Observable } from "rxjs";
import { TranslateService } from "@ngx-translate/core";
import { DigitLocaleService } from "src/app/services/digit-locale.service";
import { BsLocaleService } from "ngx-bootstrap/datepicker";
import { hiLocale } from "ngx-bootstrap/locale";
import { mrLocale } from "src/app/i18n/mr";
defineLocale("hindi", hiLocale);
defineLocale("marathi", mrLocale);

@Component({
  selector: "app-add-strength-workout",
  templateUrl: "./add-strength-workout.component.html",
  styleUrls: ["./add-strength-workout.component.scss"],
  standalone: false,
})
export class AddStrengthWorkoutComponent
  implements OnInit, ComponentCanDeactivate
{
  @ViewChild("form", { static: false }) entryForm?: NgForm;
  submitted = false;
  formProcessing = false;
  error?: string;
  maxDate = new Date();
  bsDate = new Date();
  exercisesPicked: any = [];
  exercisesSelected = false;
  submittedStep = [false, false, false, false];

  // biceps curls, Pull ups/pull ups, sit to stand and step ups
  exercises = [
    { id: "bicepCurl", label: "Bicep Curls" },
    { id: "pullUps", label: "Pull ups" },
    { id: "sitToStand", label: "Sit to Stand" },
    { id: "stepUps", label: "Step ups" },
  ];
  step = 0;
  exerciseData: { [key: string]: any } = {
    bicepCurl: { weight: null, set1: "", set2: "", set3: "", difficulty: null },
    pullUps: { weight: null, set1: "", set2: "", set3: "", difficulty: null },
    sitToStand: {
      weight: null,
      set1: "",
      set2: "",
      set3: "",
      difficulty: null,
    },
    stepUps: { weight: null, set1: "", set2: "", set3: "", difficulty: null },
  };

  constructor(
    private strengthWorkoutService: StrengthWorkoutService,
    private router: Router,
    private achievementService: AchievementService,
    private route: ActivatedRoute,
    private el: ElementRef,
    private translate: TranslateService,
    private digitLocaleService: DigitLocaleService,
    private localeService: BsLocaleService,
  ) {}

  ngOnInit(): void {
    // get the date if set
    this.route.queryParams.subscribe((params: any) => {
      if (params.d) {
        this.bsDate = moment(params.d).toDate();
      }
    });
    if (this.translate.currentLang == "hindi") {
      this.localeService.use(this.translate.currentLang);
    } else if (this.translate.currentLang == "marathi") {
      this.localeService.use(this.translate.currentLang);
    } else {
      this.localeService.use("en");
    }
  }

  onSubmit() {
    this.submitted = true;
    this.formProcessing = true;
    if (!this.entryForm?.valid) {
      Swal.fire({
        icon: "error",
        title: this.translate.instant("THIS FORM IS INVALID"),
        text: this.translate.instant("PLEASE CHECK THE FORM FOR ERRORS"),
        showConfirmButton: true,
        didClose: () => this.scrollToFirstInvalidControl(),
      });
      this.formProcessing = false;
    } else {
      // create entry
      const resourceIds = [];

      this.strengthWorkoutService
        .create(
          this.entryForm?.value.workout_date,
          this.entryForm?.value.weight,
          this.entryForm?.value.set1_reps,
          this.entryForm?.value.set2_reps,
          this.entryForm?.value.set3_reps,
          this.entryForm?.value.difficulty,
          this.exerciseData,
        )
        .subscribe(
          (responseData) => {
            this.formProcessing = false;
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: this.translate.instant("ENTRY CREATED"),
              showConfirmButton: false,
              timer: 2000,
              timerProgressBar: true,
              toast: true,
            });
            this.router.navigate(["/strength"]);
            this.entryForm?.reset();
            this.achievementService.refreshNotifications();
          },
          (error) => {
            this.error = error.message;
            this.formProcessing = false;
          },
        );
    }
  }

  onNext() {
    if (
      !this.exerciseData[this.exercisesPicked[this.step].id].weight ||
      !this.exerciseData[this.exercisesPicked[this.step].id].set1 ||
      !this.exerciseData[this.exercisesPicked[this.step].id].set2 ||
      !this.exerciseData[this.exercisesPicked[this.step].id].set3 ||
      !this.exerciseData[this.exercisesPicked[this.step].id].difficulty
    ) {
      Swal.fire({
        icon: "error",
        title: this.translate.instant("THIS FORM IS INVALID"),
        text: this.translate.instant("PLEASE CHECK THE FORM FOR ERRORS"),
        showConfirmButton: true,
        didClose: () => this.scrollToFirstInvalidControl(),
      });

      this.submittedStep[this.step] = true;
    } else {
      //  convert the weight
      if (this.exerciseData[this.exercisesPicked[this.step].id].weight) {
        this.exerciseData[this.exercisesPicked[this.step].id].weight =
          this.digitLocaleService.convertDigits(
            this.exerciseData[this.exercisesPicked[this.step].id].weight,
            this.translate.currentLang,
            "en",
          );
      }

      this.step++;
    }
  }
  onPrev() {
    this.step--;
  }

  onPickExercise(exercise: any) {
    if (this.exercisesPicked.indexOf(exercise) !== -1) {
      this.exercisesPicked.splice(this.exercisesPicked.indexOf(exercise), 1);
    } else {
      this.exercisesPicked.push(exercise);
    }
  }
  onPickAll() {
    this.exercisesPicked = [];
    this.exercises.forEach((exercise) => {
      this.exercisesPicked.push(exercise);
    });
  }
  onConfirmExercises() {
    this.exercisesSelected = true;
  }

  public scrollToFirstInvalidControl() {
    const firstInvalidControl: HTMLElement =
      this.el.nativeElement.querySelector("form .ng-invalid");

    if (firstInvalidControl) {
      firstInvalidControl.focus();
      window.scroll({
        top: this.getTopOffset(firstInvalidControl),
        left: 0,
        behavior: "smooth",
      });
    }
  }

  public getTopOffset(controlEl: HTMLElement): number {
    const labelOffset = 150;
    return controlEl.getBoundingClientRect().top + window.scrollY - labelOffset;
  }

  @HostListener("window:beforeunload")
  canDeactivate(): Observable<any> | any {
    // insert logic to check if there are pending changes here;
    // returning true will navigate without confirmation
    // returning false will show a confirm dialog before navigating away
    if (this.submitted) {
      return true;
    } else if (this.exercisesPicked.length == 0) {
      return true;
    }
  }
}
